function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.97 4a.941.941 0 01.726.298l.639.67c.041.043.079.09.111.139l4.263 4.45a1.08 1.08 0 010 1.476l-.638.669a.934.934 0 01-1.367.001L8 7.835l-3.704 3.867a.934.934 0 01-1.367 0l-.639-.67a1.08 1.08 0 01.001-1.475l4.266-4.454a1.03 1.03 0 01.108-.135l.64-.67a.943.943 0 01.665-.297z",
  fill: "currentColor"
})));